import {Component} from "@angular/core";

@Component({
    selector: "fui-canvas-window",
    styleUrls: ["./canvas-window.component.scss"],
    templateUrl: "./canvas-window.component.html"
})
export class FUICanvasWindowComponent {

}
